import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { updateHttpStatus } from '../../actions/httpStatus';
import NotFound from './NotFound.jsx';

const NOT_FOUND_HTTP_STATUS = 404;

class NotFoundContainer extends React.Component {
    constructor(props) {
        super(props);

        //this will for now only be used by Contento views
        if (this.props.shouldDispatchHttpStatus) {
            this.props.updateHttpStatus();
        }
    }

    render() {
        return <NotFound {...this.props} />;
    }
}

NotFoundContainer.propTypes = {
    shouldDispatchHttpStatus: PropTypes.bool,
};

const mapDispatchToProps = (dispatch) => {
    return {
        updateHttpStatus: () => dispatch(updateHttpStatus(NOT_FOUND_HTTP_STATUS)),
    };
};

export default connect(null, mapDispatchToProps)(NotFoundContainer);
